import { Injectable } from '@angular/core';
import { BuildSearchFilter } from '@greco/ngx-filters';

@Injectable({ providedIn: 'any' })
export class PurchaseSearchFilter extends BuildSearchFilter('PurchaseSearchFilter', {
  properties: ['user.displayName', 'user.email', 'item.displayName', 'saleCategory.label', 'user.contactEmail'],
  propertyLabels: ['User Name', 'Email Address', 'Purchase Items', 'Sales Category'],
}) {}
